import { API_BASE_URL } from "../config/config";
import { getRequest } from "./apiService";
/**
 * Calls the analyze-property endpoint with the given application ID and address.
 * @param {Object} params
 * @param {string} params.applicationId - The application ID to analyze.
 * @param {string} params.address - The address to analyze.
 * @returns {Promise<any>} - The analysis result.
 */
export const getHistoryData = async ({
  applicationId,
  access_token,
  refresh_token
}) => {
  const url = `${API_BASE_URL}/insureai/ml/intake/applications/v2/get_historical_application_data?application_id=${applicationId}
`;

  const headers = {
    accept: "application/json",
    "X-Access-Token": access_token,
    "X-Refresh-Token": refresh_token
  };

  return getRequest(url, headers);
};
